import { render, staticRenderFns } from "./productPromoCode.vue?vue&type=template&id=32f8b388&scoped=true"
import script from "./productPromoCode.vue?vue&type=script&lang=js"
export * from "./productPromoCode.vue?vue&type=script&lang=js"
import style0 from "./productPromoCode.vue?vue&type=style&index=0&id=32f8b388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f8b388",
  null
  
)

export default component.exports